import { mapActions } from 'vuex'

export const pageDisplayStatus = ({ field, formFields, displayTemplate, handleAnswer = true }) => {
  const status = {
    display: true,
    hasPgBreakLogic: false
  }
  const currentPgBreak = formFields.find(f => f.page === field.page && f.type === 'page-break')
  const pgBreakDisplayLogic = displayTemplate(currentPgBreak?.uid)
  if(currentPgBreak && pgBreakDisplayLogic?.display === false) {
    if(handleAnswer)
      field.answeredStatus = true

    if(["text-input-short", "text-input-long", "number-input"].indexOf(field.type) > -1) {
      field.content = ''
    } else if(field.type === 'date-picker') {
      field.dateSingle = ''
      field.dateMultiple = ''
      field.dateValue = ''
    } else if(["single-select","state-select"].indexOf(field.type) > -1) {
      field.selection = ''
    }

    status.display = pgBreakDisplayLogic.display
    status.hasPgBreakLogic = true
  }

  return status
}

export const getDisplayStatus = ({ field, formFields, displayTemplate, defaultDisplayLogic, previewMode = false, handleAnswer = true }) => {
  if(previewMode) return false
  const dt = displayTemplate(field.uid)
  if(displayTemplate && field.uid && dt) {
    if(dt.display === false) {
      if(["text-input-short", "text-input-long", "number-input"].indexOf(field.type) > -1) {
        field.content = ''
        if(handleAnswer)
          field.answeredStatus = false
      } else if(field.type === 'date-picker') {
        field.dateSingle = ''
        field.dateMultiple = ''
        field.dateValue = ''
        if(handleAnswer)
          field.answeredStatus = false
      } else if(['single-select','state-select'].indexOf(field.type) > -1) {
        field.selection = ''
        if(handleAnswer)
          field.answeredStatus = false
      }
    }
    const pgDisplayStatus = pageDisplayStatus({ field, formFields, displayTemplate, handleAnswer })
    if(pgDisplayStatus.hasPgBreakLogic) {
      return !pgDisplayStatus.display
    } else {
      return !dt.display
    }
  } else {
    const defaultLogic = defaultDisplayLogic[field.uid]
    return defaultLogic?.hideByDefault ? !defaultLogic.hideByDefault : false
  }
}

export default {
    data() {
        return {
          hasDisplayLogic: false,
        }
    },

    methods: {
        ...mapActions("displayLogic", ["buildTemplates"]),

        async buildDisplayLogic() {
          let displayLogicRules = [];
  
          for (let i = 0; i < this.formData.docs.length; i++) {
            const filteredRules = this.formData.docs[i]?.rules?.filter(rule => rule.type === 'Display Logic')
            if (filteredRules !== undefined) displayLogicRules = [...displayLogicRules, ...filteredRules];
          }
  
          await this.buildTemplates({
            workflowId: this.formData.id,
            workflowType: 'published',
            formElements: this.formData.fields,
            rules: displayLogicRules
          })
  
          setTimeout(() => {
            this.hasDisplayLogic = true
          },2000)
          
          return
        },
    }
}